<template>
  <div class="flex flex-col gap-4">
    <div>
      <div class="mb-1 flex items-center justify-between gap-3">
        <label for="customerMessage" class="text-sm font-medium text-gray-900">{{ t("refusal_reason") }} *</label>
        <span v-if="agentDraft" class="text-xs text-gray-500" data-test="agent-draft-hint">
          {{ t("prefilled_by_agent") }}
          <button
            v-if="customerMessage !== agentDraft"
            type="button"
            class="ml-1 font-semibold text-primary-dark hover:underline"
            data-test="restore-draft"
            @click="customerMessage = agentDraft"
          >
            {{ t("restore_draft") }}
          </button>
        </span>
      </div>
      <Textarea id="customerMessage" v-model="customerMessage" data-test="refusal-reason" />
    </div>

    <Textarea
      id="refuseEstalyManagerNotes"
      v-model="internalNotes"
      :label="t('internal_notes')"
      label-class="block text-sm font-medium leading-6 text-gray-900"
      data-test="internal-notes"
    />

    <div class="flex flex-wrap items-center justify-between gap-3">
      <p class="text-sm text-gray-500">{{ t("client_notified") }}</p>
      <GenericButton
        default-style="bg-red-600 hover:bg-red-700 border-transparent text-white"
        :disabled="!canSubmit"
        data-test="confirm"
        @click="submit"
      >
        {{ t("confirm") }}
      </GenericButton>
    </div>
  </div>
</template>

<script>
import { useI18n } from "vue-i18n";
import { mapActions } from "vuex";
import { GenericButton, Textarea } from "@estaly/ui";

export default {
  name: "ClaimRefuseForm",

  components: { GenericButton, Textarea },

  setup() {
    const { t } = useI18n();
    return { t };
  },

  props: {
    // Motif rédigé par l'agent quand il recommande le refus : une proposition que
    // l'ops relit, modifie ou remplace.
    agentDraft: {
      type: String,
      default: null,
    },
  },

  emits: ["confirmed"],

  data() {
    return {
      customerMessage: this.agentDraft || "",
      internalNotes: "",
      submitting: false,
    };
  },

  computed: {
    // Le motif part au client : un refus doit être motivé.
    canSubmit() {
      return Boolean(this.customerMessage?.trim()) && !this.submitting;
    },
  },

  methods: {
    ...mapActions("claims", ["refuseClaim"]),

    async submit() {
      this.submitting = true;
      const response = await this.refuseClaim({
        customerMessage: this.customerMessage.trim(),
        internalNotes: this.internalNotes || null,
      });
      this.submitting = false;

      if (response?.success) this.$emit("confirmed");
    },
  },
};
</script>

<i18n src="./ClaimRefuseForm.i18n.json"></i18n>
